import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { H1 } from 'scy/text';
import styles from './headerImage.mod.scss';

function imageUrl({ title, url_name }) {
  if (!title && !url_name) return null;

  const BASE_URL = 'https://saucey-media.s3.amazonaws.com/web/category-images';

  const urlName = (title || url_name)
    .toLowerCase()
    .replace(/[^\w]/g, '')
    .replace(/\s/g, '-');

  return `${BASE_URL}/${urlName}-header-image.jpg`;
}

function CategoryHeaderImage({ category = {}, loading, className, address }) {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const { title, name, url_name } = category;
  const url = loading ? null : imageUrl({ title, url_name });
  const headerName = address && name ? name : name + ' Delivery';
  const headerTitle = address && title ? title : title + ' Delivery';

  useEffect(() => {
    if (!url) return;
    setImageLoading(true);
    const image = new Image();
    image.src = url;
    image.onload = () => {
      setImageLoading(false);
      setImageError(false);
    };
    image.onerror = () => {
      setImageLoading(false);
      setImageError(true);
    };
  }, [url]);

  return (
    <div
      className={classnames(styles.container, className, {
        [styles.loading]: loading || imageLoading
      })}
      style={{ backgroundImage: imageError || !url ? null : `url(${url})` }}
    >
      <H1
        className={classnames(styles.title, { [styles.noImage]: imageError })}
      >
        {loading ? null : title ? headerTitle : name ? headerName : null}
      </H1>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    address: state.address.address
  };
}

export default connect(mapStateToProps)(CategoryHeaderImage);
